import React, { useEffect } from 'react';
import { useCookieContext } from './cookie-context';
import { CookieOutlined } from '@mui/icons-material';

const CookieIcon = () => {
  const { openPreferencesModal, isCookieIcon, setIsCookieIcon } = useCookieContext();

  useEffect(() =>{
    const login = localStorage.getItem('login');
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');

    if(login) {
      setIsCookieIcon(false);
    }
    if (login === 'false' && cookiesAccepted){
      setIsCookieIcon(true);
    }
  }, [])

  if(!isCookieIcon) return null;

  return (
    <div className="cookie-icon" onClick={openPreferencesModal}>
      <CookieOutlined sx={{fontSize: '40px'}} />
    </div>
  );
};

export default CookieIcon;
